
export default {
  props: {
    link: {
      required: true
    },
    options: {
      required: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    cOptions () {
      if (!this.options) {
        return { 
          duration: 1000,
          offset: 0,
          easing: 'easeInOutCubic' 
        }
      } else {
        return this.options;
      }
    }
  }
}
